export default __webpack_public_path__ + "static/media/Heuse & Tom Wilson - Ignite [NCS Release].b81dd9b0.mp3";